import { HtmlPageMetaContextProps } from '~/components/HtmlPageMeta/HtmlPageMetaContextProps'
import { ApplicationTrophyDto } from '~/modules/Products/Application/Dtos/ApplicationTrophyDto'
import { UserProfile } from '~/modules/Profile/UserProfile'
import { ApiTrophyResponseInterface } from '~/modules/Trophies/Application/ApiTrophyResponseInterface'

export interface TrophyDetailPageViewModel {
  htmlPageMetaContextProps: HtmlPageMetaContextProps
  trophy: ApiTrophyResponseInterface
  relatedTrophies: ApplicationTrophyDto[]
  ownerProfile?: UserProfile | null
  language: string
  owner: boolean
  backlink?: boolean
}

export function fromTrophyDetailPagePropsToViewModel (
  props: TrophyDetailPageViewModel
): TrophyDetailPageViewModel {
  return {
    htmlPageMetaContextProps: props.htmlPageMetaContextProps,
    trophy: props.trophy,
    relatedTrophies: props.relatedTrophies,
    ownerProfile: props.ownerProfile ?? null,
    language: props.language,
    owner: props.owner,
    backlink: props.backlink,
  }
}
